export const hubExportColumns = [
	{
		label: 'Community Name',
		render: h => h?.name || '',
	},
	{
		label: 'Religion',
		render: h => h?.religion?.name || '',
	},
	{
		label: 'Language',
		render: h => (Array.isArray(h?.language) ? h.language.map(l => l.name).join(', ') : ''),
	},
	{
		label: 'Native Place',
		render: h => (Array.isArray(h?.nativeplace) ? h.nativeplace.map(n => n.name).join(', ') : ''),
	},
	{
		label: 'Caste',
		render: h => h?.caste?.name || '',
	},
	{
		label: 'Total Users',
		render: h => h?.users?.length || 0,
	},
	{
		label: 'Admin Name',
		render: h => (h?.admin ? `${h.admin.firstName || ''} ${h.admin.lastName || ''}` : ''),
	},
	{
		label: 'Admin Mobile',
		render: h => h?.admin?.mobile || '',
	},
	{
		label: 'Created Date',
		render: h => (h?.createdAt ? new Date(h.createdAt).toLocaleDateString('en-IN') : ''),
	},
]
